import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, Teleport as _Teleport } from "vue"
import _imports_0 from '@/assets/login/homeMe.png'
import _imports_1 from '@/assets/imgcaptions/shopIcon.png'
import _imports_2 from '@/assets/imgcaptions/cn.png'
import _imports_3 from '@/assets/imgcaptions/en.png'


const _hoisted_1 = { class: "mainBox" }
const _hoisted_2 = { class: "mainImgBox" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mainListBox" }
const _hoisted_6 = { class: "abilityStyletitle" }
const _hoisted_7 = { class: "language-selector" }
const _hoisted_8 = { class: "menu-container" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "mask"
}
const _hoisted_11 = { class: "maskBox" }
const _hoisted_12 = { class: "maskBoxTop" }

import {
  computed,
  getCurrentInstance,
  nextTick,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import {
  Close,
  Search,
} from "@element-plus/icons-vue";
// 账户信息
import userBox from "@/views/sys/user/index.vue"
import pwdBox from "@/views/sys/pwd/index.vue"

import { ElMessageBox } from "element-plus/es";
import { logout } from "@/api/Login";
import AccountApi from "@/api/AccountApi";
import headPic from '@/assets/aivoice/ico_morentouxiang.svg';
import Cookies from 'js-cookie';

export default /*@__PURE__*/_defineComponent({
  __name: 'mainBox',
  props: {
    onLogin: {
        type: Boolean,
        default: false,
    },
},
  emits: ['closeAll','loginOut','changeLanguage','showLogin'],
  setup(__props, { expose: __expose, emit: __emit }) {

const showMask=ref(false)
let { proxy } = getCurrentInstance()
// 是否显示路由列表
const showOnOffMain=ref(false)
const emit = __emit
const showMain=()=>{
    closes()
    emit('closeAll')
    showOnOffMain.value=!showOnOffMain.value
   
}
const mainImg=ref({})
const props = __props
const showLogin=ref(false)
watch(()=>props.onLogin,(newVal)=>{
    showLogin.value=newVal
})
onMounted(()=>{
    mainImg.value=JSON.parse(localStorage.getItem('user')).user
    showLogin.value=props.onLogin
    // console.log( mainImg.value)
})
const titleName=ref('')
const closeThis=()=>{
    isuser.value=false
    showMask.value=false
    isPwd.value=false
}
// 账户信息
const isuser=ref(false)
const account=()=>{
    closeThis()
    titleName.value='账户信息'
    isuser.value=true
    showMask.value=true
}
// 修改密码
const isPwd=ref(false)
const editpassword=()=>{
    closeThis()
    titleName.value='修改密码'
    isPwd.value=true
    showMask.value=true
}
// 退出
const exitFun=()=>{
   
    logout().then(() => {
      proxy.$ws.close();
      AccountApi.toLogin();
      showLogin.value=false
      showOnOffMain.value=false
      emit('loginOut')
    });
  
}
const closes=()=>{
    
    if(showOnOffMain.value){
        showOnOffMain.value=false
    }
    if(showMaskLanguage.value){
        showMaskLanguage.value=false
    }
    
}
// 显示登录框
const showLoginfun=()=>{
    showMaskLanguage.value=false
    emit('showLogin')
}   
// 切换语言类型
const showMaskLanguage = ref(false)
const activeLanguage = ref('')

const languageList = [
    { lang: 'en', name: 'English' },
    { lang: 'zh-CN', name: '简体中文' }
]

const showLanguage = () => {
    closes()
    showMaskLanguage.value = true
}

const selectLanguage = (lang: string) => {
    const item = languageList.find(item => item.lang === lang)
    if (item) {
        activeLanguage.value = item.name
        localStorage.setItem('language', item.lang)
        emit('changeLanguage', item.lang)
    }
}

onMounted(() => {
    const lang = localStorage.getItem('language') || 'zh-CN'
    const item = languageList.find(item => item.lang === lang)
    activeLanguage.value = item?.name || '简体中文'
})
__expose({
    closes,

})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (mainImg.value.avatar!=undefined && mainImg.value.avatar!=''&& showLogin.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(proxy).getimgUrl+ mainImg.value.avatar,
            alt: "",
            class: "mainImgStyle",
            onClick: _withModifiers(showMain, ["stop"])
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      ((mainImg.value.avatar==undefined || mainImg.value.avatar=='') && showLogin.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _unref(headPic),
            alt: "",
            onClick: _withModifiers(showMain, ["stop"])
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      (!showLogin.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: _imports_0,
            alt: "",
            onClick: _withModifiers(showLoginfun, ["stop"]),
            class: "mainImgnoLogin"
          }))
        : _createCommentVNode("", true),
      (showLogin.value)
        ? (_openBlock(), _createElementBlock("span", {
            key: 3,
            class: "mainNameStyle",
            onClick: _withModifiers(showMain, ["stop"])
          }, _toDisplayString(mainImg.value.nickname), 1))
        : _createCommentVNode("", true),
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_1,
        alt: "",
        class: "imgBtnen"
      }, null, -1)),
      _withDirectives(_createElementVNode("img", {
        src: _imports_2,
        alt: "",
        class: "imgBtn",
        onClick: _withModifiers(showLanguage, ["stop"])
      }, null, 512), [
        [_vShow, activeLanguage.value=='简体中文']
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_3,
        alt: "",
        class: "imgBtn",
        onClick: _withModifiers(showLanguage, ["stop"])
      }, null, 512), [
        [_vShow, activeLanguage.value=='English']
      ])
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "animate__animated animate__fadeIn",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "个人中心", -1)),
            _createVNode(_component_el_icon, {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showOnOffMain.value=false), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Close))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: "abilityStyle",
            onClick: _withModifiers(account, ["stop"])
          }, "账号信息"),
          _createElementVNode("div", {
            class: "abilityStyle",
            onClick: _withModifiers(editpassword, ["stop"])
          }, "修改密码"),
          _createElementVNode("div", {
            class: "abilityStyle",
            onClick: _withModifiers(exitFun, ["stop"])
          }, "退出")
        ], 512), [
          [_vShow, showOnOffMain.value]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "animate__animated animate__fadeIn",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(languageList, (item, index) => {
              return _createElementVNode("div", {
                class: _normalizeClass(["menu-item", { active: item.name === activeLanguage.value }]),
                key: index,
                onClick: _withModifiers(($event: any) => (selectLanguage(item.lang)), ["stop"])
              }, _toDisplayString(item.name), 11, _hoisted_9)
            }), 64))
          ])
        ], 512), [
          [_vShow, showMaskLanguage.value]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (showMask.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, _toDisplayString(titleName.value), 1),
                  _createVNode(_component_el_icon, {
                    onClick: _withModifiers(closeThis, ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Close))
                    ]),
                    _: 1
                  })
                ]),
                (isuser.value)
                  ? (_openBlock(), _createBlock(userBox, { key: 0 }))
                  : _createCommentVNode("", true),
                (isPwd.value)
                  ? (_openBlock(), _createBlock(pwdBox, { key: 1 }))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    ])
  ]))
}
}

})